<template>
  <div
    class="article-page"
    :style="[
      themeStyle,
      backgroundImage,
    ]"
  >
    <!-- <ImagePreview
      v-if="selectImage"
      :image="selectImage"
      @hide-img="hideImg"
    /> -->
    <div
      class="article-content"
      :style="{ width: configData.style.board.useboard ? `${configData.style.board.config['--content-margin']}%` : '90%' }"
    >
      <!-- 麵包屑導覽 -->
      <div class="article-breadcrumb">
        <div class="breadcrumb-wrapper">
          <b-breadcrumb>
            <b-breadcrumb-item :to="{name: 'home'}">
              <feather-icon
                icon="HomeIcon"
                size="16"
                class="align-text-top"
              />
            </b-breadcrumb-item>
            <b-breadcrumb-item
              v-for="item, index in breadcrumbData"
              :key="index"
              :active="item.active"
              :to="item.to"
            >
              {{ item.text }}
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
      <div class="article_top">
        <h2 class="pageName">
          {{ articleName }}
        </h2>
        <div class="pageInfo">
          <div class="mr-1">
            {{ dayjs(articleData.last_updated_at).format('YYYY-MM-DD HH:MM:ss') }}
          </div>
          <div class="mr-1">
            {{ articleData.author ? articleData.author : '匿名' }}
          </div>
          <div>
            瀏覽次數：{{ articleData.page_views ? articleData.page_views : 0 }}
          </div>
        </div>
      </div>
      <div class="article animate__animated animate__fadeInUp">
        <wang-editor-preview
          :content="articleData.detail"
          @select-img="selectImg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BBreadcrumb, BBreadcrumbItem, VBTooltip,
  // BImg, BTable, BSkeletonTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import dayjs from 'dayjs'

// import ImagePreview from '@/layouts/components/ImagePreview.vue'
import WangEditorPreview from '@/layouts/components/WangEditorPreview.vue'

import router from '@/router'

export default {
  components: {
    // BImg,
    BBreadcrumb,
    BBreadcrumbItem,
    // ImagePreview,
    WangEditorPreview,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectImage: null,
      themeStyle: null,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
    backgroundImage() {
      const bgImg = {}
      if (this.configData.style.board.useboard) bgImg.backgroundImage = `url(${this.baseUrl}${this.configData.style.board.mid.image})`
      if (!bgImg.backgroundImage) {
        bgImg.padding = '50px 0'
        bgImg.borderRadius = this.configData.style.board.config['--border-radius']
        bgImg.backgroundColor = this.configData.style.board.config['--board-bg-color']
        bgImg.borderColor = this.configData.style.board.config['--board-border-color']
        bgImg.borderStyle = this.configData.style.board.config['--board-border-style']
        bgImg.borderWidth = this.configData.style.board.config['--board-border-width']
      }
      return bgImg
    },
  },
  mounted() {
    this.themeStyle = this.configData.style.board.config
  },
  methods: {
    dayjs,
    // (刪減)文字
    shortenTxtLength(txt) {
      if (!txt) return ''
      let resolve = txt
      if (txt.length > 12) {
        txt.substr(0, 12)
        resolve = `${txt.substr(0, 12)}...`
      }
      return resolve
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    selectImg(imgData) {
      const selectIndex = imgData.imgIndex
      const imgList = [...imgData.imgList].map(img => img.src)
      const startList = imgList.slice(selectIndex)
      const endList = imgList.slice(0, selectIndex)
      const data = [...startList, ...endList]
      this.$viewerApi({
        images: data,
        options: {
          navbar: false,
          movable: false,
        },
      })
    },
    hideImg() {
      this.selectImage = null
    },
  },
  setup(props) {
    const breadcrumbData = ref([])

    const articleId = ref(null)
    const articleName = ref('')
    const classId = ref(null)
    const className = ref()
    const boardTitle = ref('')
    const articleData = ref(null)

    const getCategoryConfig = () => {
      articleId.value = router.currentRoute.params.article_id
      articleName.value = props.configData.data.title
      classId.value = props.configData.data.class_id
      className.value = props.configData.data.class_info.name
      boardTitle.value = props.configData.style.board.title

      breadcrumbData.value.push({
        text: '論壇',
        to: { name: 'home', params: { id: router.currentRoute.params.id } },
      })
      breadcrumbData.value.push({
        text: boardTitle.value,
        to: { name: 'category' },
      })
      breadcrumbData.value.push({
        text: className.value,
        to: { name: 'class', params: { category_id: classId.value, category_name: className.value } },
      })
      breadcrumbData.value.push({
        text: articleName.value,
        active: true,
      })
      articleData.value = props.configData.data
    }
    // #EE1B2E #33CCFF #EE5023 #3C9D40 #8F2A90

    getCategoryConfig()
    return {
      articleData,
      breadcrumbData,
      articleId,
      articleName,
      classId,
      className,
      getCategoryConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
$breadcrumb-color: var(--breadcrumb-color);
$board-color: var(--board-color);
$board-title-color: var(--board-title-color);
$board-icon-color: var(--board-icon-color);
$board-bg-color: var(--board-bg-color);
$board-mobile-bg-color: var(--board-mobile-bg-color);
$border-radius: var(--border-radius);
$board-border-color: var(--board-border-color);
$board-border-style: var(--board-border-style);
$board-border-width: var(--board-border-width);
$shadow-color: var(--shadow-color);
$shadow-inset-color: var(--shadow-inset-color);
$brightness: var(--brightness);
$link-color: var(--link-color);

a{
  &:hover {
    color: $link-color !important;
    text-decoration: none;
  }
}

.float:hover {
  transform: translateY(-5px);
}
.brightness:hover {
  filter: brightness(calc(calc(100 + var(--brightness)) * 1%));
}

.opacity:hover {
  opacity: calc(var(--images-opacity) * 1%);
}

.shadow {
  box-shadow: none !important;
  filter: drop-shadow(3px 3px 5px $shadow-color);
  &:hover {
    filter: drop-shadow(3px 3px 10px $shadow-inset-color);
  }
}

.article-page {
  background-position: center;
  background-repeat: repeat-y;
  background-size: contain;
}

.article-content {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 70%;
  min-height: 60vh;
  margin: auto;
}
.article-breadcrumb {
  position: relative;
  left: 0%;
  display: flex;
  margin-bottom: 1rem;
  .breadcrumb-item, .breadcrumb-item a{
    color: $breadcrumb-color;
  }
  .breadcrumb-item.active {
    color: $link-color;
  }
  // @media screen and (min-width: 991px) {
  //   left: 0;
  // }
}
.article_top {
  position: relative;
  margin-left: 1rem;
  padding: clamp(5px,2vw,20px) 0;
  border-bottom: 1px solid $board-title-color;
  .pageName {
    font-size: clamp(20px, 5vw, 28px);
    color: $board-title-color;
  }
  .pageInfo {
    display: flex;
    flex-wrap: wrap;
    font-size: clamp(12px, 2vw, 16px);
    color: $board-title-color;
    font-weight: bold;
  }
}
</style>
